export class AudioRecorderService {
  private static getSupportedMimeType(): string {
    const mimeTypes = ["audio/webm;codecs=opus", "audio/webm", "audio/ogg;codecs=opus", "audio/mp4"]

    for (const mimeType of mimeTypes) {
      if (MediaRecorder.isTypeSupported(mimeType)) {
        return mimeType
      }
    }

    return "audio/webm"
  }

  static async requestMicrophonePermission(): Promise<MediaStream> {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        audio: {
          echoCancellation: true,
          noiseSuppression: true,
          autoGainControl: true,
        },
      })
      return stream
    } catch (error) {
      if (error instanceof Error) {
        if (error.name === "NotAllowedError") {
          throw new Error("Microphone permission denied")
        } else if (error.name === "NotFoundError") {
          throw new Error("No microphone found")
        } else {
          throw new Error(`Failed to access microphone: ${error.message}`)
        }
      }
      throw new Error("Failed to access microphone")
    }
  }

  static createMediaRecorder(stream: MediaStream): MediaRecorder {
    return new MediaRecorder(stream, {
      mimeType: this.getSupportedMimeType(),
      audioBitsPerSecond: 128000,
    })
  }

  static formatDuration(seconds: number): string {
    const hours = Math.floor(seconds / 3600)
    const minutes = Math.floor((seconds % 3600) / 60)
    const secs = Math.floor(seconds % 60)

    if (hours > 0) {
      return `${hours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}:${secs.toString().padStart(2, "0")}`
    }

    return `${minutes.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`
  }

  static createAudioFile(chunks: Blob[], mimeType?: string): File {
    const audioBlob = new Blob(chunks, { type: mimeType || "audio/webm" })
    const timestamp = new Date().toISOString().replace(/[:.]/g, "-")
    const fileName = `recording-${timestamp}.webm`

    return new File([audioBlob], fileName, {
      type: audioBlob.type,
      lastModified: Date.now(),
    })
  }
}
